import { render, staticRenderFns } from "./StudentsListAction.vue?vue&type=template&id=5ce55c50&"
import script from "./StudentsListAction.vue?vue&type=script&lang=js&"
export * from "./StudentsListAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports